<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="beetleUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="beetles"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-beetle
      :beetle="{ abbreviation: '', name: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-beetle
      :key="beetleUpdateKey"
      :beetle="selectedBeetle"
      :visible="dialogType === 'update'"
      :id="selectedBeetle.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-beetle
      :visible="dialogType === 'delete'"
      :beetle="selectedBeetle"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-beetle>
  </div>
</template>

<script>
import CreateBeetle from "./CreateBeetle";
import UpdateBeetle from "./UpdateBeetle";
import DeleteBeetle from "./DeleteBeetle.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateBeetle,
    UpdateBeetle,
    DeleteBeetle,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "name" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      beetleUpdateKey: null,
      beetleList: [],
      isLoading: false,
      dialogType: "",
      selectedBeetle: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "beetles"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchBeetles", "createBeetle", "updateBeetle"]),
    editBeetle(beetle) {
      this.selectedBeetle = { ...beetle };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },

    openModal(type, beetle) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedBeetle = { ...beetle };
      }
    },
    openDeleteModal(type, beetle) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedBeetle = { ...beetle };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedBeetle = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedBeetle = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createBeetle(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateBeetle(item);
      this.beetleUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchBeetles()
        .then(() => {
          this.$store.commit("setBeetleTypeResults", response.data);
          this.beetles = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  handleSearch(query) {
    this.getSearchquery = query;
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
